/**
 * Test mode only: keep the Web-to-Lead preview the server returned, so the
 * end-to-end channel matrix can read it after the page moves on. The server
 * returns `w2l` only for a request with a valid x-rh-test header, so for a
 * real visitor this does nothing.
 */
export function rememberW2lPreview(result: unknown): void {
  const w2l = (result as { w2l?: Record<string, string> } | null)?.w2l;
  if (!w2l || typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem("rh_w2l_preview", JSON.stringify(w2l));
  } catch {
    // Storage blocked: the check reads nothing and reports it.
  }
}
